import React, { useState } from 'react';
import {
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TextField,
    Autocomplete,
    Snackbar,
    Alert
} from '@mui/material';
import { userRequest } from '../../requestMethods';
import PageContainer from '../layout/PageContainer';

import DeleteIcon from '@mui/icons-material/Delete'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

let dictionaryWordTemplate = {
    word: '',
    translation: [
        {
            spacyPos: 'NOUN',
            one: '',
            all: []
        }
    ]
}

let translationTemplate = { spacyPos: 'NOUN', one: '', all: [] }

const DictionaryWordEditor = () => {
    const [word, setWord] = useState('');

    const [translationArray, setTranslationArray] = useState([translationTemplate]);
    const [newTranslation, setNewTranslation] = useState(translationTemplate)

    const [dictionaryWord, setDictionaryWord] = useState(dictionaryWordTemplate)
    // const [newDictionaryWord, setNewDictionaryWord] = useState(null)

    const [searchFound, setSearchFound] = useState(null)
    const [addWordMode, setAddWordMode] = useState(false)

    const [showMessageBox, setShowMessageBox] = useState(false)
    const [messageBoxContent, setMessageBoxContent] = useState("Done!")
    const [messageBoxType, setMessageBoxType] = useState("success")

    const posOptions = ['POS', 'ADJ', 'ADP', 'ADV', 'AUX', 'CONJ', 'CCONJ', 'DET', 'INTJ', 'NOUN', 'NUM', 'PART', 'PHRASE', 'PRON', 'PROPN', 'PUNCT', 'SCONJ', 'SYM', 'VERB'];


    const handleSearch = async () => {
        const result = await userRequest.get(`/dictionaryWord/search/${word}`)
        // console.log(result.data.exists)
        if (result.data) {
            setSearchFound(result.data.exists)
            setAddWordMode(!result.data.exists)
            if (result.data.exists) {
                setDictionaryWord(result.data.dictionaryWord)
                setTranslationArray(result.data.dictionaryWord.translation);
            }
        }
        else {
            setSearchFound(null)
            setAddWordMode(false)
        }
    };

    const onSearchFieldChange = (e) => {
        setWord(e.target.value);
        setSearchFound(null)
        setDictionaryWord(dictionaryWordTemplate)
        setTranslationArray([translationTemplate])
    }

    // const handleAskLLM = async() => {
    //     let wordsList = {
    //         'words': [word]
    //     }
    //     const result = await userRequest.post(`/generate/dictionary`, wordsList)
        
    //     console.log(result)
    //     if (result.data) {
    //         console.log(result.data)
    //     }
    //     else {
            
    //     }
    //     // console.log(result)
    // }

    // Add/Create word in DB
    const handleAddWordButton = async () => {
        let newWord = { 
            word: word,
            translation: [{ ...newTranslation }]
        }
        // console.log(newWord)
        const result = await userRequest.post('/dictionaryWord', newWord)
        
        setShowMessageBox(true)
        if (result.data) {
            setMessageBoxContent("Added!")
            setMessageBoxType("success")
            setAddWordMode(false)
            setNewTranslation(translationTemplate)
        }
        else {
            setMessageBoxContent("Something is wrong. Check console.")
            setMessageBoxType("error")
            console.log(result)
        }
    };

    // Update word in DB
    const handleUpdateButton = async () => {
        let word = {
            ...dictionaryWord,
            translation: translationArray
        }
        // console.log(word)
        const result = await userRequest.put(`/dictionaryWord/${dictionaryWord._id}`, word)
        
        setShowMessageBox(true)
        if (result.data) {
            if (result.data) {
                setMessageBoxContent("Updated succesfully!")
                setMessageBoxType("success")
            }
            else {
                setMessageBoxContent("Something is wrong. Check console.")
                setMessageBoxType("error")
            }    
        }
        else {
            setMessageBoxContent("Something is wrong. Check console.")
            setMessageBoxType("error")
        }
        // console.log(result)
    };

    const onSnackbarClose = (e) => {
        setShowMessageBox(false)
    }

    const handleAddTranslationButton = (e) => {
        translationArray.push({ ...translationTemplate })
        setTranslationArray([...translationArray])
    }

    const onTranslationFieldChange = (index, field, newValue) => {
        let updatedTranslation = { ...translationArray[index] }
        if (field === "spacyPos") {
            updatedTranslation.spacyPos = newValue
        } 
        else if (field === "one") {
            updatedTranslation.one = newValue
        }
        else if (field === "all") {
            updatedTranslation.all = newValue.split(",")
        }
        translationArray[index] = { ...updatedTranslation }
        setTranslationArray([...translationArray])
    }

    const handleRemoveTranslation = (index) => {
        translationArray.splice(index, 1)
        setTranslationArray([...translationArray])
    }

    return (
        <PageContainer maxWidth="lg">
            <Typography variant="h4" gutterBottom>
                Dictionary Words
            </Typography>
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <TextField 
                    label="Word" 
                    fullWidth
                    value={word} 
                    onChange={onSearchFieldChange} 
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && word.length > 0) {
                            e.preventDefault();
                            handleSearch();
                        }
                    }}
                    sx={{ mb: 2 }}
                />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button 
                        variant="contained" 
                        onClick={handleSearch}
                        disabled={word.length === 0}
                    >
                        Search
                    </Button>
                    {searchFound != null && 
                        <Typography sx={{ ml: 2, fontStyle: 'italic' }}>
                            {'"' + word}{searchFound ? '" found' : '" not found'}
                        </Typography>
                    }
                </div>
            </Paper>
            
            <br/>
            
            {/* <Button variant='outlined' onClick={handleAskLLM}>Ask LLM</Button> */}

            <Snackbar open={showMessageBox}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                autoHideDuration={6000} onClose={onSnackbarClose}>
                <Alert onClose={onSnackbarClose} severity={messageBoxType} sx={{ width: '100%' }}>
                    {messageBoxContent}
                </Alert>
            </Snackbar>

            <br />

            {searchFound &&
                <>
                    <Table>
                        <TableBody>
                            {translationArray && translationArray.map((tran, index) =>
                                <>
                                    <TableRow>
                                        <TableCell> .spacyPos: </TableCell>
                                        <TableCell>
                                            <Autocomplete
                                                value={tran.spacyPos}
                                                onChange={(event, newValue) => {
                                                    onTranslationFieldChange(index, "spacyPos", newValue)
                                                }}
                                                options={posOptions}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> .one </TableCell>
                                        <TableCell>
                                            <TextField value={tran.one} onChange={(e) => {
                                                    onTranslationFieldChange(index, "one", e.target.value)
                                                }} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>.all</TableCell>
                                        <TableCell>
                                            <TextField value={tran.all} onChange={(e) => {
                                                    onTranslationFieldChange(index, "all", e.target.value)
                                                }} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={3}>
                                            <Button 
                                                variant="outlined" 
                                                startIcon={<DeleteIcon/>}
                                                onClick={(e) => handleRemoveTranslation(index)}
                                            >
                                                Remove
                                            </Button>
                                            <hr />
                                        </TableCell>
                                    </TableRow>
                                </>
                            )}
                        </TableBody>
                    </Table>
                    <p>
                        <Button 
                            variant='contained'
                            onClick={handleAddTranslationButton}
                        >
                            Add translation
                        </Button>
                    </p>

                    <Button variant="outlined" onClick={handleUpdateButton}>Update translation</Button>
                </>
            }

            {addWordMode &&
                <>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell> .spacyPos: </TableCell>
                                <TableCell>
                                    <Autocomplete
                                        value={newTranslation.spacyPos}
                                        onChange={(event, newValue) => {
                                            setNewTranslation({...newTranslation, spacyPos: String(newValue)})
                                            // console.log(newValue)
                                        }}
                                        options={posOptions}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell> .one </TableCell>
                                <TableCell>
                                    <TextField 
                                        value={newTranslation.one} 
                                        onChange={(e) => setNewTranslation({ ...newTranslation, one: e.target.value})} 
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>.all</TableCell>
                                <TableCell>
                                    <TextField 
                                        value={newTranslation.all} 
                                        onChange={(e) => setNewTranslation({ ...newTranslation, all: e.target.value.split(',')})} 
                                    /> Use only comma "," to split words, do not put space after comma, e.g. "first,first off,beginning"
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <hr />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Button variant="outlined" onClick={handleAddWordButton}>Add Word</Button>
                </>
            }

            <p>
            <hr/>
            </p>
            
            <p> <InfoOutlinedIcon fontSize='large' variant='outlined'></InfoOutlinedIcon> spaCy POS (point of speech) values</p>
            <Table>
                <TableHead>
                    <TableRow><TableCell>POS</TableCell><TableCell>DESCRIPTION</TableCell><TableCell>EXAMPLES</TableCell></TableRow>
                </TableHead>
                <TableBody>
                    <TableRow><TableCell>ADJ</TableCell><TableCell>adjective</TableCell><TableCell>*big, old, green, incomprehensible, first*</TableCell></TableRow>
                    <TableRow><TableCell>ADP</TableCell><TableCell>adposition</TableCell><TableCell>*in, to, during*</TableCell></TableRow>
                    <TableRow><TableCell>ADV</TableCell><TableCell>adverb</TableCell><TableCell>*very, tomorrow, down, where, there*</TableCell></TableRow>
                    <TableRow><TableCell>AUX</TableCell><TableCell>auxiliary</TableCell><TableCell>*is, has (done), will (do), should (do)*</TableCell></TableRow>
                    <TableRow><TableCell>CONJ</TableCell><TableCell>conjunction</TableCell><TableCell>*and, or, but*</TableCell></TableRow>
                    <TableRow><TableCell>CCONJ</TableCell><TableCell>coordinating conjunction</TableCell><TableCell>*and, or, but*</TableCell></TableRow>
                    <TableRow><TableCell>DET</TableCell><TableCell>determiner</TableCell><TableCell>*a, an, the*</TableCell></TableRow>
                    <TableRow><TableCell>INTJ</TableCell><TableCell>interjection</TableCell><TableCell>*psst, ouch, bravo, hello*</TableCell></TableRow>
                    <TableRow><TableCell>NOUN</TableCell><TableCell>noun</TableCell><TableCell>*girl, cat, tree, air, beauty*</TableCell></TableRow>
                    <TableRow><TableCell>NUM</TableCell><TableCell>numeral</TableCell><TableCell>*1, 2017, one, seventy-seven, IV, MMXIV*</TableCell></TableRow>
                    <TableRow><TableCell>PART</TableCell><TableCell>particle</TableCell><TableCell>*'s, not,*</TableCell></TableRow>
                    <TableRow><TableCell>PRON</TableCell><TableCell>pronoun</TableCell><TableCell>*I, you, he, she, myself, themselves, somebody*</TableCell></TableRow>
                    <TableRow><TableCell>PROPN</TableCell><TableCell>proper noun</TableCell><TableCell>*Mary, John, London, NATO, HBO*</TableCell></TableRow>
                    <TableRow><TableCell>PUNCT</TableCell><TableCell>punctuation</TableCell><TableCell>*., (, ), ?*</TableCell></TableRow>
                    <TableRow><TableCell>SCONJ</TableCell><TableCell>subordinating conjunction</TableCell><TableCell>*if, while, that*</TableCell></TableRow>
                    <TableRow><TableCell>SYM</TableCell><TableCell>symbol</TableCell><TableCell>*$, %, §, ©, +, −, ×, ÷, =, :), 😝*</TableCell></TableRow>
                    <TableRow><TableCell>VERB</TableCell><TableCell>verb</TableCell><TableCell>*run, runs, running, eat, ate, eating*</TableCell></TableRow>
                    <TableRow><TableCell>VERB</TableCell><TableCell>phrase</TableCell><TableCell>*grow old, grow up, take out, burst off*</TableCell></TableRow>
                    <TableRow><TableCell>X</TableCell><TableCell>other</TableCell><TableCell>*sfpksdpsxmsa*</TableCell></TableRow>
                    <TableRow><TableCell>SPACE</TableCell><TableCell>space</TableCell></TableRow>
                </TableBody>
            </Table>
        </PageContainer>
    );
};

export default DictionaryWordEditor;
